import Container from "./Container";

const Skill = () => {
  return (
    <div className="py-20" id="skill">
      <Container>
        <h2 className="text-3xl font-bold text-center mb-8 tracking-wider">
          SKILL
        </h2>
        <section>
          <div className="mx-auto grid gap-8 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 text-center justify-center">
            <div className="">
              <i className="devicon-html5-plain text-6xl mx-auto  p-color"></i>
              <h3 className="font-bold mt-2">HTML5</h3>
            </div>
            <div>
              <i className="devicon-css3-plain text-6xl mx-auto  p-color"></i>
              <h3 className="font-bold mt-2">CSS3</h3>
            </div>
            <div>
              <i className="devicon-javascript-plain text-6xl mx-auto  p-color"></i>
              <h3 className="font-bold mt-2">Javascript</h3>
            </div>
            <div>
              <i className="devicon-react-original text-6xl mx-auto p-color"></i>

              <h3 className="font-bold mt-2">React.js</h3>
            </div>
            <div>
              <i className="devicon-nextjs-plain text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">Next.js</h3>
            </div>
            <div>
              <i className="devicon-tailwindcss-original text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">Tailwind</h3>
            </div>
            <div>
              <i className="devicon-redux-original text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">Redux</h3>
            </div>
            <div>
              <i className="devicon-git-plain text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">Git</h3>
            </div>
            <div>
              <i className="devicon-github-original text-6xl mx-auto p-color"></i>

              <h3 className="font-bold mt-2">Github</h3>
            </div>
            <div>
              <i className="fa-solid fa-terminal text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">Command Line</h3>
            </div>
            <div>
              <i className="fa-solid fa-gears text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">API</h3>
            </div>
            <div>
              <i className="devicon-vscode-plain  text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">VS Code</h3>
            </div>
            <div>
              <i className="fa-solid fa-mobile-screen text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">Responsive</h3>
            </div>
            <div>
              <i className="fa-solid fa-magnifying-glass text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">SEO</h3>
            </div>
            <div>
              <i className="fa-solid fa-earth-oceania text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">English</h3>
            </div>
            <div>
              <i className="fa-solid fa-language text-6xl mx-auto p-color"></i>
              <h3 className="font-bold mt-2">Japanese</h3>
            </div>
          </div>
        </section>
      </Container>
    </div>
  );
};

export default Skill;
